import React, { useEffect, useState } from "react";
import "./Header.css";
import { Link, NavLink } from "react-router-dom";
import LogoIcon from "../../assets/img/logo-icon-white.png";
import LaunchpadIcon from "../../assets/img/Rocket.svg";
import StakingIcon from "../../assets/img/Chart.svg";
import SwapIcon from "../../assets/img/Arrow.svg";
import FarmIcon from "../../assets/img/Tractor.svg";
import GovernanceIcon from "../../assets/img/People.svg";
import DocsIcon from "../../assets/img/Book.svg";
import BridgeIcon from "../../assets/img/Bridge.svg";
import SolIcon from "../../assets/img/sol-icon.png";
import StacksIcon from "../../assets/img/stacks-logo.png";
import ConnectWalletDialog from "../../components/ConnectWalletDialog";
import useGlobalState from "../../global/state";
import {omitMiddleText} from "../../utils/string"

// import triggerNotification from "../../helper/Notification";


const Header = () => {
  const [unisatWallet, setUnisatWallet] = useGlobalState('unisatWallet');
  const [walletConnectingStatus, setWalletConnectingStatus] = useGlobalState('walletConnectingStatus');

  const [mblFull, setmblFull] = useState(false);
  const [progressComing2, setprogressComing2] = useState(false);
  const [modalPop, setmodalPop] = useState(false);
  const [progressComing, setprogressComing] = useState(false);
  const [drop, setDrop] = useState(false);


  // useEffect(()=> {
  //   console.log("unisatWallet => ", unisatWallet);
  // }, [unisatWallet]);

  let toggleMbl = () => {
    if (mblFull === false) {
      setmblFull(true);
    } else {
      setmblFull(false);
    }
  };
  let closePop = () => {
    setDrop(false);
    if (modalPop === false) {
      setmodalPop(true);
    } else {
      setmodalPop(false);
    }
  };
  let progressToggle2 = () => {
    setprogressComing2(true);
    setTimeout(() => {
      // progressComing ? setprogressComing2(false) : setprogressComing2(true);
      setprogressComing2(false);
    }, 5000);
  };
  let toggleDrop = () => {
    if (drop === false) {
      setDrop(true);
    } else {
      setDrop(false);
    }
  };

  let onDisconnect = () => {
    setDrop(false);
    setWalletConnectingStatus("disconnected");
    setUnisatWallet(null);

    // triggerNotification(
    //   "Wallet",
    //   `Wallet disconnected. Stay safe`,
    //   "info"
    // );
  };

  return (
    <div>
      {drop && <div className="overlay" onClick={toggleDrop}></div>}
      {unisatWallet && unisatWallet.connected ? (
      <div>
        <div className="MuiStack-root connectbtn">
          <button
          onClick={toggleDrop}
            className={
              drop
                ? "MuiButtonBase-root activebtn MuiButton-root MuiButton-outlined MuiButton-outlinedSecondary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-root MuiButton-outlined MuiButton-outlinedSecondary MuiButton-sizeMedium MuiButton-outlinedSizeMedium mui-style-532m1e"
                : "MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedSecondary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-root MuiButton-outlined MuiButton-outlinedSecondary MuiButton-sizeMedium MuiButton-outlinedSizeMedium mui-style-532m1e"
            }
            tabindex="0"
            type="button"
          >
            <p className="MuiTypography-root MuiTypography-body1 mui-style-vh8ben">
              <i class="fa-solid fa-charging-station"></i> {omitMiddleText(unisatWallet.address, 10)}
            </p>
            <span className="MuiTouchRipple-root mui-style-w0pj6f"></span>
          </button>
          <div
              className={
                drop
                  ? "MuiPaper-root MuiPaper-elevation disconnectHeight MuiPaper-rounded MuiPaper-elevation8 MuiPopover-paper mui-style-1ek0hrx"
                  : "MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation8 MuiPopover-paper mui-style-1ek0hrx"
              }
              tabIndex={-1}
            >
              <ul
                className="MuiList-root MuiList-padding MuiMenu-list mui-style-bc12dn"
                role="menu"
                tabIndex={-1}
              >
                <li
                  onClick={onDisconnect}
                  className="MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters MuiMenuItem-root MuiMenuItem-gutters mui-style-j77aub"
                  tabIndex={0}
                  role="menuitem"
                >
                  {/* <img
                    alt="logo"
                    width={24}
                    height={24}
                    decoding="async"
                    data-nimg={1}
                    src="data:image/svg+xml;base64,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"
                    style={{ color: "transparent", marginRight: "8px" }}
                  /> */}
                  Disconnect
                  <span className="MuiTouchRipple-root mui-style-w0pj6f" />
                </li>
              </ul>
            </div>    
        </div>
      </div>
      ) : (
        <div>
          <div className="MuiStack-root connectbtn">
            <button
              onClick={toggleDrop}
              className={
                drop
                  ? "MuiButtonBase-root activebtn MuiButton-root MuiButton-outlined MuiButton-outlinedSecondary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-root MuiButton-outlined MuiButton-outlinedSecondary MuiButton-sizeMedium MuiButton-outlinedSizeMedium mui-style-532m1e"
                  : "MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedSecondary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButton-root MuiButton-outlined MuiButton-outlinedSecondary MuiButton-sizeMedium MuiButton-outlinedSizeMedium mui-style-532m1e"
              }
              tabindex="0"
              type="button"
            >
              <p className="MuiTypography-root MuiTypography-body1 mui-style-vh8ben">
                <i class="fa-solid fa-charging-station"></i> Connect Wallet
              </p>
              <span className="MuiTouchRipple-root mui-style-w0pj6f"></span>
            </button>
            <div
              className={
                drop
                  ? "MuiPaper-root MuiPaper-elevation activeHeight MuiPaper-rounded MuiPaper-elevation8 MuiPopover-paper mui-style-1ek0hrx"
                  : "MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation8 MuiPopover-paper mui-style-1ek0hrx"
              }
              tabIndex={-1}
            >
              <ul
                className="MuiList-root MuiList-padding MuiMenu-list mui-style-bc12dn"
                role="menu"
                tabIndex={-1}
              >
                <li
                  onClick={closePop}
                  className="MuiButtonBase-root MuiMenuItem-root MuiMenuItem-gutters MuiMenuItem-root MuiMenuItem-gutters mui-style-j77aub"
                  tabIndex={0}
                  role="menuitem"
                >
                  <img
                    alt="logo"
                    width={24}
                    height={24}
                    decoding="async"
                    data-nimg={1}
                    src="data:image/svg+xml;base64,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"
                    style={{ color: "transparent", marginRight: "8px" }}
                  />
                  Bitcoin
                  <span className="MuiTouchRipple-root mui-style-w0pj6f" />
                </li>
                <li
                  className="MuiButtonBase-root disabled MuiMenuItem-root MuiMenuItem-gutters MuiMenuItem-root MuiMenuItem-gutters mui-style-j77aub"
                  tabIndex={-1}
                  role="menuitem"
                >
                  <img
                    alt="Ethereum"
                    width={24}
                    height={24}
                    decoding="async"
                    data-nimg={1}
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE1NF83MjA5KSI+CjxwYXRoIGQ9Ik0xMiAyNEMxOC42Mjc0IDI0IDI0IDE4LjYyNzQgMjQgMTJDMjQgNS4zNzI1OCAxOC42Mjc0IDAgMTIgMEM1LjM3MjU4IDAgMCA1LjM3MjU4IDAgMTJDMCAxOC42Mjc0IDUuMzcyNTggMjQgMTIgMjRaIiBmaWxsPSIjNjI3RUVBIi8+CjxwYXRoIGQ9Ik0xMiAzVjkuNjUyNUwxNy42MjI4IDEyLjE2NUwxMiAzWiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC42MDIiLz4KPHBhdGggZD0iTTEyLjM3MzUgM0w2Ljc1IDEyLjE2NUwxMi4zNzM1IDkuNjUyNVYzWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEyIDE2Ljc2NFYyMS4yODQzTDE3LjYyNjUgMTMuNUwxMiAxNi43NjRaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjYwMiIvPgo8cGF0aCBkPSJNMTIuMzczNSAyMS4yODQzVjE2Ljc2MzNMNi43NSAxMy41TDEyLjM3MzUgMjEuMjg0M1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMiAxNS41MjU4TDE3LjYyMjggMTIuMjYxTDEyIDkuNzVWMTUuNTI1OFoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNNi43NSAxMi4yNjFMMTIuMzczNSAxNS41MjU4VjkuNzVMNi43NSAxMi4yNjFaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjYwMiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzE1NF83MjA5Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="
                    style={{
                      color: "transparent",
                      marginRight: "8px",
                      borderRadius: "50%",
                    }}
                  />
                  EVM Chain
                  <span className="MuiTouchRipple-root mui-style-w0pj6f" />
                </li>
                <li
                  className="MuiButtonBase-root disabled MuiMenuItem-root MuiMenuItem-gutters MuiMenuItem-root MuiMenuItem-gutters mui-style-j77aub"
                  tabIndex={-1}
                  role="menuitem"
                >
                  <img
                    alt="Stacks"
                    width={24}
                    height={24}
                    decoding="async"
                    data-nimg={1}
                    src={StacksIcon}
                    style={{
                      color: "transparent",
                      marginRight: "8px",
                      borderRadius: "50%",
                    }}
                  />
                  Stacks
                  <span className="MuiTouchRipple-root mui-style-w0pj6f" />
                </li>
                {/* <li
                  className="MuiButtonBase-root disabled MuiMenuItem-root MuiMenuItem-gutters MuiMenuItem-root MuiMenuItem-gutters mui-style-j77aub"
                  tabIndex={-1}
                  role="menuitem"
                >
                  <img
                    alt="Solana"
                    width={24}
                    height={24}
                    decoding="async"
                    data-nimg={1}
                    src={SolIcon}
                    style={{
                      color: "transparent",
                      marginRight: "8px",
                      borderRadius: "50%",
                    }}
                  />
                  Solana
                  <span className="MuiTouchRipple-root mui-style-w0pj6f" />
                </li>
                <li
                  className="MuiButtonBase-root disabled MuiMenuItem-root MuiMenuItem-gutters MuiMenuItem-root MuiMenuItem-gutters mui-style-j77aub"
                  tabIndex={-1}
                  role="menuitem"
                >
                  <img
                    alt="BNB Smart Chain"
                    width={24}
                    height={24}
                    decoding="async"
                    data-nimg={1}
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfODI4XzExNjYwKSI+CiAgICA8cGF0aAogICAgICBkPSJNMTIgMjRDMTguNjI3NCAyNCAyNCAxOC42Mjc0IDI0IDEyQzI0IDUuMzcyNTggMTguNjI3NCAwIDEyIDBDNS4zNzI1OCAwIDAgNS4zNzI1OCAwIDEyQzAgMTguNjI3NCA1LjM3MjU4IDI0IDEyIDI0WiIKICAgICAgZmlsbD0iI0YzQkEyRiIgLz4KICAgIDxwYXRoCiAgICAgIGQ9Ik05LjA4NyAxMC44MDNMMTIgNy44OUwxNC45MTQ1IDEwLjgwNDVMMTYuNjA5NSA5LjEwOTVMMTIgNC41TDcuMzkyIDkuMTA4TDkuMDg3IDEwLjgwM1pNNC41IDEyTDYuMTk1IDEwLjMwNUw3Ljg5IDEyTDYuMTk1IDEzLjY5NUw0LjUgMTJaTTkuMDg3IDEzLjE5N0wxMiAxNi4xMUwxNC45MTQ1IDEzLjE5NTVMMTYuNjA5NSAxNC44ODk4TDEyIDE5LjVMNy4zOTIgMTQuODkyTDcuMzg5NzUgMTQuODg5OEw5LjA4NyAxMy4xOTdaTTE2LjExIDEyTDE3LjgwNSAxMC4zMDVMMTkuNSAxMkwxNy44MDUgMTMuNjk1TDE2LjExIDEyWk0xMy43MTkgMTEuOTk4NUgxMy43MjA1VjEyTDEyIDEzLjcyMDVMMTAuMjgxNyAxMi4wMDNMMTAuMjc4NyAxMkwxMC4yODE3IDExLjk5NzdMMTAuNTgyNSAxMS42OTYyTDEwLjcyODggMTEuNTVMMTIgMTAuMjc5NUwxMy43MTk3IDExLjk5OTJMMTMuNzE5IDExLjk5ODVaIgogICAgICBmaWxsPSJ3aGl0ZSIgLz4KICA8L2c+CiAgPGRlZnM+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwXzgyOF8xMTY2MCI+CiAgICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiIC8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KPC9zdmc+"
                    style={{
                      color: "transparent",
                      marginRight: "8px",
                      borderRadius: "50%",
                    }}
                  />
                  BNB Chain
                  <span className="MuiTouchRipple-root mui-style-w0pj6f" />
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      )}

      <div
        onClick={() => setDrop(false)}
        className={mblFull ? "side-bar mbl-open pt-10" : "side-bar pt-10"}
      >
        <NavLink to="/" className="p20">
          <img src={LogoIcon} className="logo-icon" alt="" />
        </NavLink>
        <div className="side-links">
          <NavLink to="/launchpad" className="individual-link">
            <div className="link-ico">
              <img src={LaunchpadIcon} height="25px" width="25px" />
            </div>
            <p className="link-title">Launchpad</p>
            <div className="absolute top-[-10px] right-0 abs-numer">
              <div className="relative w-4 h-4">
                <div className="w-full h-full custom-clr rounded-full absolute inset-0 animate-ping2" />
                <div className="w-full h-full custom-clr rounded-full absolute inset-0 inline-flex items-center justify-center text-gamefiDark-900 leading-none font-bold">
                  1
                </div>
              </div>
            </div>
          </NavLink>
        </div>
        <NavLink to="/staking" className="individual-link">
          <div className="link-ico">
            <img src={StakingIcon} height="25px" width="25px" />
          </div>
          <p className="link-title">Staking</p>
        </NavLink>
        <NavLink to="/swap" className="individual-link">
          <div className="link-ico">
            <img src={SwapIcon} height="25px" width="25px" />
          </div>
          <p className="link-title">Swap</p>
        </NavLink>
        <button
          onClick={progressToggle2}
          disabled={progressComing2 ? true : false}
          className="individual-link"
        >
          <div className="link-ico">
            <img src={FarmIcon} height="25px" width="25px" />
          </div>
          <p className="link-title">Earn</p>
        </button>

        <NavLink to="/bridge" className="individual-link">
          <div className="link-ico">
            <img src={BridgeIcon} height="25px" width="25px" />
          </div>
          <p className="link-title">Bridge</p>
        </NavLink>

        <NavLink to="/governance" className="individual-link">
          <div className="link-ico">
            <img src={GovernanceIcon} height="25px" width="25px" />
          </div>
          <p className="link-title">Governance</p>
        </NavLink>
        <a
          href="https://satopad-finance.gitbook.io/satopad-finance/"
          target="_blank"
          className="individual-link"
        >
          <div className="link-ico">
            <img src={DocsIcon} height="25px" width="25px" />
          </div>
          <p className="link-title">Docs</p>
        </a>
      </div>
      <div className="mobile-belowBar">
        <div className="flex-mbl">
          <NavLink to="/launchpad" className="mbl-individual mbl-active">
            <span className="active-underline"></span>
            <div className="mbl-icon">
              <img src={LaunchpadIcon} height="25px" width="25px" />
            </div>
          </NavLink>
          <NavLink to="/staking" className="mbl-individual ">
            <span className="active-underline"></span>
            <div className="mbl-icon">
              <img src={StakingIcon} height="25px" width="25px" />
            </div>
          </NavLink>
          <NavLink to="/swap" className="mbl-individual ">
            <span className="active-underline"></span>
            <div className="mbl-icon">
              <img src={SwapIcon} height="25px" width="25px" />
            </div>
          </NavLink>

          <NavLink to="/governance" className="mbl-individual ">
            <span className="active-underline"></span>
            <div className="mbl-icon">
              <img src={GovernanceIcon} height="25px" width="25px" />
            </div>
          </NavLink>
          <div onClick={toggleMbl} className="mbl-individual ">
            <span className="active-underline"></span>
            <div className="mbl-icon">
              <img
                src={
                  mblFull
                    ? "https://gamefi.org/_next/static/media/x.f956a27b.svg"
                    : "https://gamefi.org/_next/static/media/menuToggler.7ea29bb4.svg"
                }
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      {/* <button className="nav-link btn-wallet">
        <i className="fas fa-wallet"></i> Connect
      </button> */}

      {/*  */}
      <div className="c-container">
        <div
          className={
            progressComing ? "popup-coming right-full" : "popup-coming  "
          }
        >
          <div className="toast-tba">
            <div onClick={() => setprogressComing(false)} className="cross-ico">
              <i className="fa-solid fa-x"></i>
            </div>
            <div className="toast-txt">
              <div className="toast-ico">
                <i
                  className="fa-solid fa-circle-info"
                  style={{ color: "white" }}
                ></i>
              </div>
              <div className="toast-written">Swap coming soon </div>
            </div>
          </div>
          <div className="progress-bar"></div>
        </div>
        <div
          className={
            progressComing2 ? "popup-coming right-full2 " : "popup-coming  "
          }
        >
          <div className="toast-tba">
            <div
              onClick={() => setprogressComing2(false)}
              className="cross-ico"
            >
              <i className="fa-solid fa-x"></i>
            </div>
            <div className="toast-txt">
              <div className="toast-ico">
                <i
                  className="fa-solid fa-circle-info"
                  style={{ color: "white" }}
                ></i>
              </div>
              <div className="toast-written">Farm under maintenance!</div>
            </div>
          </div>
          <div className="progress-bar"></div>
        </div>
      </div>

      {/*  */}
      <ConnectWalletDialog modalPop={modalPop} closePop={closePop}/>
    </div>
  );
};

export default Header;
